import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import moment from 'moment';

const createQueryParams = (page, pageSize, filters) => {
  const params = new URLSearchParams();
  
  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });
  }

  return params.toString();
};

// export const fetchRegistrationDetails = createAsyncThunk(
//   'registration/fetchRegistrationDetails',
//   async ({ jwtBearer, page, pageSize, filters } = {}) => {
//     const queryParams = createQueryParams(page, pageSize, filters);
//     const response = await axios.get(`${BASE_URL}pipeline/registration/details/${queryParams ? `?${queryParams}` : ''}`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}`
//       }
//     });
//     return response.data;
//   }
// );

export const fetchRegistrationDetails = createAsyncThunk(
  'registration/fetchRegistrationDetails',
  async ({ jwtBearer, page, pageSize, filters } = {}, { rejectWithValue }) => {
    try {
      const queryParams = createQueryParams(page, pageSize, filters);
      const response = await axios.get(
        `${BASE_URL}pipeline/registration/details/${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      console.error('Fetch error:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


export const fetchFilteredRegistrationDetails = createAsyncThunk(
  'registration/fetchFilteredRegistrationDetails',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}pipeline/registration/details/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);


export const downloadRegistrationReport = createAsyncThunk(
  'downloadRegistrationReport',
  async ({ jwtBearer }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}pipeline/registration/download/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${jwtBearer}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to generate report');
      }

      const blob = await response.blob();

      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `Registration_Report.xlsx`;
      link.click();

      // Clean up the temporary URL
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading registration report:', error);
      return rejectWithValue(error.message);
    }
  }
);



const registrationSlice = createSlice({
  name: 'registrationDetails',
  initialState: {
    data: [],
    loading: false,
    error: null,
    totalCount: 0,

    filteredData: [],
    filteredLoading: false,
    filteredError: null,
    filteredTotalCount: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegistrationDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRegistrationDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.registration_data;
        console.log("state.data",state.data)
        state.totalCount = action.payload.data.total_registration_data; 
        console.log("state.data.total_registration_data",state.totalCount) 
      })
      .addCase(fetchRegistrationDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFilteredRegistrationDetails.pending, (state) => {
        state.filteredLoading = true;
        state.filteredError = null;
      })
      .addCase(fetchFilteredRegistrationDetails.fulfilled, (state, action) => {
        state.filteredLoading = false;
        state.filteredData = action.payload.data.registration_data;
        state.filteredTotalCount = action.payload.data.total_registration_data || 0;
      })
      .addCase(fetchFilteredRegistrationDetails.rejected, (state, action) => {
        state.filteredLoading = false;
        state.filteredError = action.error.message;
      });
  }
});


export default registrationSlice.reducer;
